import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";

class MotivoRechazo extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'combustible/one', saveUrl: 'combustible/save', backUrl: '/Catalogo/PreciosCombustibles' },
      new Form([
        Form.Field('text', 'combustible_precio_valor', 'Valor', '', [Validators.required], 6),
      ], ['Guardar'], 'Precio Combustible'), this.formData
    )
    if (this.props.match.params.id)
      this.LoadPreds()
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(MotivoRechazo)
